// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-header[data-v-6922c8ec]{margin-bottom:1.5rem}.enrollments-list[data-v-6922c8ec]>:not(:last-child){margin-bottom:1.5rem}.enrollments-list[data-v-6922c8ec]>:last-child{margin-bottom:3rem}", ""]);
// Exports
module.exports = exports;
